// extracted by mini-css-extract-plugin
export default {"Loading":"Loading_Loading__6KY-H","lds-ring":"Loading_lds-ring__ipfnx"};